'use strict';

exports.__esModule = true;

var _ramda = /*#__PURE__*/require('ramda');

var _isInteger = /*#__PURE__*/require('./isInteger');

var _isInteger2 = /*#__PURE__*/_interopRequireDefault(_isInteger);

var _isFinite = /*#__PURE__*/require('./isFinite');

var _isFinite2 = /*#__PURE__*/_interopRequireDefault(_isFinite);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Checks whether the passed value is a `float`.
 *
 * @func isFloat
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.14.0|v1.14.0}
 * @category Type
 * @sig * -> Boolean
 * @param {*} val The value to test
 * @return {boolean}
 * @see {@link RA.isNotFloat|isNotFloat}
 * @example
 *
 * RA.isFloat(0); //=> false
 * RA.isFloat(1); //=> false
 * RA.isFloat(-100000); //=> false
 *
 * RA.isFloat(0.1);       //=> true
 * RA.isFloat(Math.PI);   //=> true
 *
 * RA.isFloat(NaN);       //=> false
 * RA.isFloat(Infinity);  //=> false
 * RA.isFloat(-Infinity); //=> false
 * RA.isFloat('10');      //=> false
 * RA.isFloat(true);      //=> false
 * RA.isFloat(false);     //=> false
 * RA.isFloat([1]);       //=> false
 */
var isFloat = /*#__PURE__*/(0, _ramda.both)(_isFinite2.default, /*#__PURE__*/(0, _ramda.complement)(_isInteger2.default));

exports.default = isFloat;


//////////////////
// WEBPACK FOOTER
// ./~/ramda-adjunct/lib/isFloat.js
// module id = 277
// module chunks = 168707334958949